import * as React from 'react';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import {
    GLOBAL,
    LOAN_APPLICATION,
} from '../../../../constants/LabelConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import InputText from '../../../../../common/components/InputText';
import {PersonalDataSectionProps} from '../../../../types/mx/turboCash/components';

class PersonalDataSectionView extends React.Component<PersonalDataSectionProps, {}> {

    constructor(props) {
        super(props);
    }

    render() {
        const {
            civilStatusSelectedField,
            civilStatus,
            regime,
            regimeSelectedField,
            rolHome,
            rolHomeSelectedField,
            studies,
            studiesSelectedField,
            houseType,
            houseTypeSelectedField,
            amountDependentsField,
            cURPField,
            showErrors
        } = this.props;
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION.CIVIL_STATUS}
                            id={INPUTS.CIVIL_STATUS}
                            placeholder={GLOBAL.SELECT}
                            value={civilStatusSelectedField.value}
                            data={civilStatus}
                            required
                            onChange={this.props.onChangeCivilStatus}
                            labelError={civilStatusSelectedField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION.REGIME}
                            id={INPUTS.REGIME}
                            placeholder={GLOBAL.SELECT}
                            value={regimeSelectedField.value}
                            data={regime}
                            required
                            onChange={this.props.onChangeRegime}
                            labelError={regimeSelectedField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION.ROLE_HOME}
                            id={INPUTS.ROLE_HOME}
                            placeholder={GLOBAL.SELECT}
                            value={rolHomeSelectedField.value}
                            data={rolHome}
                            required
                            onChange={this.props.onChangeRolHome}
                            labelError={rolHomeSelectedField.error}
                            hasError={showErrors}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION.STUDIES}
                            id={INPUTS.STUDIES}
                            placeholder={GLOBAL.SELECT}
                            value={studiesSelectedField.value}
                            data={studies}
                            required
                            onChange={this.props.onChangeStudies}
                            labelError={studiesSelectedField.error}
                            hasError={showErrors}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION.AMOUNT_DEPENDENTS}
                                   id={INPUTS.AMOUNT_DEPENDENTS}
                                   value={amountDependentsField.value}
                                   required
                                   hasError={showErrors}
                                   labelError={amountDependentsField.error}
                                   type={InputTextTypes.NUMBER}
                                   onChange={this.props.onChangeAmountDependents}/>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <InputText label={LOAN_APPLICATION.CURP}
                                   id={INPUTS.CURP}
                                   value={cURPField.value}
                                   required
                                   maxLength={18}
                                   hasError={showErrors}
                                   labelError={cURPField.error}
                                   onChange={this.props.onChangeCURP}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12 col-md-6 col-lg-4">
                        <SelectSearchComponent
                            label={LOAN_APPLICATION.HOME_TYPE}
                            id={INPUTS.HOME_TYPE}
                            placeholder={GLOBAL.SELECT}
                            value={houseTypeSelectedField.value}
                            data={houseType}
                            required
                            onChange={this.props.onChangeHouseType}
                            labelError={houseTypeSelectedField.error}
                            hasError={showErrors}/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default PersonalDataSectionView;